import { useQuery } from "@tanstack/react-query";
import { fetchMe } from "@/shared/api/auth";
import { hasActionPermission } from "./permission-client";

/** Effective company permission keys for Desk gating — plan/15 + plan/40 Edit. */
export function useCompanyHeld(companySlug: string | undefined) {
  const meQuery = useQuery({
    queryKey: ["auth", "me"],
    queryFn: fetchMe,
    staleTime: 60_000,
    enabled: Boolean(companySlug),
  });

  const me = meQuery.data ?? null;
  const company = me?.companies.find((c) => c.slug === companySlug);
  const held =
    me?.user.isSuperadmin && !company?.permissions?.length
      ? (["*"] as string[])
      : (company?.permissions ?? []);
  const effectiveHeld = held.length
    ? held
    : me?.user.isSuperadmin
      ? (["*"] as string[])
      : [];

  function can(action: string): boolean {
    return hasActionPermission(effectiveHeld, action);
  }

  return {
    held: effectiveHeld,
    can,
    ready: Boolean(me) || meQuery.isError,
    isPending: meQuery.isPending,
  };
}
